module.exports = __webpack_public_path__ + "media/assets/icons/24-hours-30dcf1de31bed02c606701509bc37b4b.svg";